import { Questionnaire } from '../Questionnaires/types';
import { QuestionnaireOption } from './interface';
import { useQuestionnaire } from './useQuestionnaire';
import { createOptions, getSelectedOption } from './utils';

interface UseQuestionnaireOptionsProps {
  questionnaires: Questionnaire[];
  selectedQuestionnaireId?: string;
}

interface UseQuestionnaireOptionsReturn {
  options: QuestionnaireOption[];
  selectedOption?: QuestionnaireOption | null;
}

function useQuestionnaireOptions({
  questionnaires,
  selectedQuestionnaireId
}: UseQuestionnaireOptionsProps): UseQuestionnaireOptionsReturn {
  const { questionnaire } = useQuestionnaire(selectedQuestionnaireId);
  const selectedOption = getSelectedOption(questionnaires, selectedQuestionnaireId, questionnaire);

  return {
    options: createOptions(questionnaires),
    selectedOption
  };
}

export default useQuestionnaireOptions;
